import type { DeepString } from "@/lib/i18n";

export const pl = {
  defaultTitle: "Najczęściej zadawane pytania",
} as const;

export type WFaqTranslations = DeepString<typeof pl>;
